export default __webpack_public_path__ + "static/media/jess-fastcompany.8a3a71df.jpg";